import { NgModule } from '@angular/core';
import { BiApiModule } from '@selfai-platform/bi-api';
import { WidgetEntityStoreModule } from './widget';
import { DashboardEntityStoreModule } from './dashboard';

@NgModule({
  imports: [WidgetEntityStoreModule, DashboardEntityStoreModule,BiApiModule.forRoot()],
})
export class BiDomainModule {}
